import { FirebaseError } from "firebase/app";
import { Link, useNavigate } from "react-router";
import { LinkButton } from "../../components/Button";
import Divider from "../../components/Divider";
import Form from "../../components/Form";
import FormField from "../../components/FormField";
import East from "../../components/icons/east.svg?react";
import Input from "../../components/Input";
import { useAuth } from "../../context/authContext";
import styles from "./Signup.module.css";

interface ResetBody {
  email: string;
}

const Reset = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <div>
      <header className={styles.header}>
        <Link to="#" className={styles.logo}>
          only clicks
        </Link>
      </header>
      <div className={styles.container}>
        <h1 className={styles.title}>Reset your password</h1>
        <Form<ResetBody>
          submitText="Reset"
          onSubmit={({ value: { email }, formApi }) =>
            auth
              .sendPasswordResetEmail(email)
              .then(() => navigate("/reset/sent", { state: { email } }))
              .catch((err: FirebaseError) => {
                switch (err.code) {
                  default:
                    formApi.setErrorMap({
                      onServer:
                        "Unexpected error occurred. Please try again." as never,
                    });
                    console.error(err);
                }
              })
          }
        >
          {(form) => (
            <div className={styles.formFields}>
              <form.Field name="email">
                {(field) => (
                  <FormField label="Email address" field={field}>
                    <Input
                      id={field.name}
                      name={field.name}
                      type="email"
                      required={true}
                      value={field.state.value}
                      onBlur={field.handleBlur}
                      onChange={(e) => field.handleChange(e.target.value)}
                    />
                  </FormField>
                )}
              </form.Field>
            </div>
          )}
        </Form>
        <Divider text="or" />
        <p className={styles.login}>
          Remember your password?
          <LinkButton linkProps={{ to: "/login" }} glyph={East}>
            Login
          </LinkButton>
        </p>
      </div>
    </div>
  );
};

export default Reset;
